export interface OnboardingContextDTO {
  invitationId?: string;
  to?: string;
  companyAccount?: InvitationCompanyAccountData;
  userAccount?: InvitationUserAccountDataDTO;
  invitationType?: InvitationType;
}

export interface InvitationCompanyAccountData {
  id?: string;
  name?: string;
  companyRegistrationNumber?: string;
  legalForm?: LegalForm;
}

export interface InvitationUserAccountDataDTO {
  firstName?: string;
  lastName?: string;
}

export enum InvitationType {
  ONBOARD_NEW_COMPANYACCOUNT = 'ONBOARD_NEW_COMPANYACCOUNT',
  REGISTER_SANDBOX_ACCOUNT = 'REGISTER_SANDBOX_ACCOUNT',
  JOIN_EXISTING_COMPANYACCOUNT = 'JOIN_EXISTING_COMPANYACCOUNT',
  ONBOARD_DEBITOR = 'ONBOARD_DEBITOR',
  ONBOARD_AGENT_CLIENT = 'ONBOARD_AGENT_CLIENT',
}

export enum LegalForm {
  GmbH = 'GmbH',
  GmbHCoKG = 'GmbHCoKG',
  AG = 'AG',
  GbR = 'GbR',
  OHG = 'OHG',
  KG = 'KG',
  UG = 'UG',
  EU = 'EU',
  FB = 'FB',
  EG = 'EG',
  EV = 'EV',
}
